import cimg1 from '../images/category/img-1.jpg'
import cimg2 from '../images/category/img-2.jpg'
import cimg3 from '../images/category/img-3.jpg'
import cimg4 from '../images/category/img-4.jpg'
import cimg5 from '../images/category/img-5.jpg'
import cimg6 from '../images/category/img-6.jpg'



const CoursesCategory = [
   {
      Id: '1',
      cImg: cimg1,
      thumb: 'flaticon-computer',
      title: 'Technology & Digital Skills',
      slug: 'Technology-&-Digital-Skills',
      description: 'Essential technology and digital skills for the modern world to help you stay ahead.',
   },
   {
      Id: '2',
      cImg: cimg2,
      thumb: 'flaticon-heartbeat',
      title: 'Health & Wellbeing',
      slug: 'Health-&-Wellbeing',
      description: 'Comprehensive health and wellness programs for a better and healthier lifestyle.'
   },
   {
      Id: '3',
      cImg: cimg3,
      thumb: 'flaticon-growth',
      title: 'Finance & Economy',
      slug: 'Finance-&-Economy',
      description: 'Master financial planning and economic principles for sustainable growth.'
   },
   {
      Id: '4',
      cImg: cimg4,
      thumb: 'flaticon-briefcase',
      title: 'Business & Entrepreneurship',
      slug: 'Business-&-Entrepreneurship',
      description: 'Build successful businesses and entrepreneurial ventures with expert guidance.'
   },
   {
      Id: '5',
      cImg: cimg5,
      thumb: 'flaticon-medal',
      title: 'Leadership & Personal Development',
      slug: 'Leadership-&-Personal-Development',
      description: 'Develop leadership skills and personal growth strategies for success.'
   },
   {
      Id: '6',
      cImg: cimg6,
      thumb: 'flaticon-globe',
      title: 'Environment & Sustainability',
      slug: 'Environment-&-Sustainability',
      description: 'Learn about environmental protection and sustainable practices for future generations.'
   },

]

export default CoursesCategory;